import React, { useMemo } from 'react';
import classnames from 'classnames';
import { examMarkGenerator } from 'utils/ExamMarks';

import Container from 'components/Misc/Container';

const Distribution = ({ tasks, className }) => {
	const cls = classnames(
		'flex bg-white dark:bg-neutral-800 rounded-lg',
		className
	);

	// Store mark distribution segments
	const segments = useMemo(() => {
		// Calculate max points receivable in exam
		const max = tasks?.reduce((result, task) => {
			return result + (task.points * task.sample);
		}, 0);

		// Create mark distribution
		return examMarkGenerator(max);
	}, [tasks]);

	// Do not render empty distribution
	if (!segments.length) return null;

	return (
		<Container className={cls}>
			{segments?.map(segment =>
				<div key={segment.mark} className="my-3 px-4 flex-1 text-center">
					<div className="text-base font-bold text-neutral-800 dark:text-white transition-colors">
						{segment.mark}
					</div>

					<div className="font-light text-sm text-neutral-700 dark:text-white transition-colors">
						{segment.start} - {segment.end}
					</div>
				</div>
			)}
		</Container>
	);
};

export default Distribution;